import { BlobReplaceDTO, IssueConversionClient, IssueClient, NewIssueData, PubIssueDTO, ConversionLogModel, IIssueStorageClient, IssueStorageClient, IssueStorageDTO, IIssueTrackingClient, IssueTrackingClient, IssueTrackingLogModel, ISysClient, SysClient, ApiAuditModel } from "../Generated/ParticaAPI";

export interface IIssueConversionService {
	getSourceBlob(issueId: number): Promise<BlobReplaceDTO>;
	restartIssue(issueId: number): Promise<any>;
	getRecentConversions(): Promise<PubIssueDTO[]>;
	getConversionLog(issueId: number): Promise<ConversionLogModel[]>;
	getIssueSourceBlobFile(issueId: number, filename: string): Promise<BlobReplaceDTO>;
	processMultiPage(issueId: number, files: string[]): Promise<any>;
	getStorageStatus(issueId: number): Promise<IssueStorageDTO>;
	getIssueTrackingLog(issueId: number): Promise<IssueTrackingLogModel[]>;
	getApiAudit(issueId: number): Promise<ApiAuditModel[]>;
}

export class IssueConversionService implements IIssueConversionService {
	private svc: IssueConversionClient = new IssueConversionClient();
	private issuesvc: IssueClient = new IssueClient();
	private issuestorageservice: IIssueStorageClient = new IssueStorageClient();
	private issuetracking: IIssueTrackingClient = new IssueTrackingClient();
	private sys: ISysClient = new SysClient();

	public async getSourceBlob(issueId: number): Promise<BlobReplaceDTO> {
		return await this.svc.getIssueSourceBlob(issueId);
	}
	public async getIssueSourceBlobFile(issueId: number, filename: string): Promise<BlobReplaceDTO> {
		return await this.svc.getIssueSourceBlobFile(issueId, "singlepagepdf/" + filename);
	}
	public async restartIssue(issueId: number): Promise<any> {
		return await this.svc.restartIssue(issueId);
	}
	public async getRecentConversions(): Promise<PubIssueDTO[]> {
		return await this.svc.getRecentConversions();
	}
	public async getConversionLog(issueId: number): Promise<ConversionLogModel[]> {
		return await this.svc.getIssueLog(issueId);
	}
	public async processMultiPage(issueId: number, files: string[]): Promise<any> {
		return await this.svc.processMultiPage(issueId, files);
	}
	public async getStorageStatus(issueId: number): Promise<IssueStorageDTO> {
		return await this.issuestorageservice.getIssueStorage(issueId);
	}
	public async getIssueTrackingLog(issueId: number): Promise<IssueTrackingLogModel[]> {
		return await this.issuetracking.getWorkLog(issueId);
	}
	public async getApiAudit(issueId: number): Promise<ApiAuditModel[]> {
		return await this.sys.getIssueAudit(issueId);
	}
}
